<template>
  <CommonDialog
    :dialog.sync="dialog"
    :head-text="headText"
    :confirm-button="confirmButton"
    :on-cancel="close"
    :on-confirm="update"
    max-width="900px"
  >
    <v-form ref="form">
      <v-row>
        <v-col class="py-0" cols="12" sm="4">
          <v-autocomplete
            v-model="document._folder.id"
            :items="folders"
            item-text="name"
            item-value="id"
            :label="$t('documents.folder')"
            :rules="[backEndValidation('folder_id')]"
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col class="py-0" cols="12" sm="4">
          <v-autocomplete
            v-model="document.status"
            :items="statuses"
            :label="$t('documents.status')"
            item-text="name"
            item-value="id"
            :rules="[backEndValidation('status')]"
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col class="py-0" cols="12" sm="4">
          <v-checkbox
            v-if="draftCount"
            v-model="document.final"
            color="primary"
            :label="$tc('documents.from-draft-to-finalized', draftCount)"
            class="checkbox"
          ></v-checkbox>
        </v-col>
        <v-col class="py-0" cols="12">
          <v-text-field
            v-model="document.name"
            :label="$t('documents.name')"
            :rules="[backEndValidation('name')]"
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
      <v-divider class="my-5" />
      <v-row>
        <v-col class="py-0" cols="12" sm="4">
          <v-autocomplete
            disabled
            v-model="type_id"
            :items="types"
            :label="$t('documents.type')"
            item-text="name"
            item-value="id"
            :rules="[backEndValidation('document_type')]"
          ></v-autocomplete>
        </v-col>
        <v-col class="py-0" cols="12" sm="4">
          <v-select
            v-model="template_id"
            :items="templates"
            :label="$t('documents.template')"
            item-text="name"
            item-value="id"
            :rules="[backEndValidation('template')]"
            clearable
          ></v-select>
        </v-col>
        <v-col class="py-0" cols="12" sm="4">
          <v-autocomplete
            v-model="document.language"
            :items="languages"
            :label="$t('documents.language')"
            clearable
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-divider class="my-5" />
      <v-row>
        <v-col class="py-0" cols="12" sm="4">
          <AutocompleteContacts
            :item="document._receiver.id"
            label="documents.receiver"
            :updated="updateReceiver"
            clearable
          ></AutocompleteContacts>
        </v-col>
        <v-col class="py-0" cols="12" sm="4">
          <AutocompleteContacts
            :item="document._creditor.id"
            label="documents.creditor"
            :updated="updateCreditor"
            clearable
          ></AutocompleteContacts>
        </v-col>
        <v-col class="py-0" cols="12" sm="4">
          <AutocompleteContacts
            :item="document._sender.id"
            label="documents.sender"
            :updated="updateSender"
            clearable
          ></AutocompleteContacts>
        </v-col>
      </v-row>
      <v-divider class="my-5" />
      <v-row>
        <v-col class="py-0" cols="12">
          <v-textarea
            clearable
            v-model="document.notices"
            :label="$t('documents.notices')"
            :rules="[backEndValidation('notices')]"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-form>
  </CommonDialog>
</template>

<script>
import { rules } from "../mixins/rules";
import { permissions } from "../mixins/permissions";
import CommonDialog from "../common/dialogs/CommonDialog";
import AutocompleteContacts from "../common/inputs/AutocompleteContacts";
export default {
  name: "DialogForMassUpdate",
  components: { CommonDialog, AutocompleteContacts },
  mixins: [rules, permissions],
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: function() {
        return [];
      }
    },
    onSuccess: {
      type: Function,
      default: function() {
        return function() {};
      }
    },
    confirmButton: {
      type: Object,
      default: function() {
        return {
          text: this.$t("documents.update"),
          icon: "mdi-pencil"
        };
      }
    },
    headText: {
      type: String,
      default: function() {
        return this.$t("documents.update");
      }
    },
    contentText: {
      type: String
    }
  },
  data: () => ({
    document: {
      _folder: { id: null },
      _template: {
        id: null,
        _type: { id: null }
      },
      _receiver: { id: null },
      _creditor: { id: null },
      _sender: { id: null },
      field_contents: {
        Status: null
      }
    }
  }),
  watch: {
    selected: {
      handler: function() {
        function Prototype(pathGet = () => {}) {
          this.store = new Set();
          this.pathGet = pathGet;
          this.add = function(i) {
            this.store.add(this.pathGet(i));
          };
          this.get = function() {
            return this.store.size === 1
              ? this.store.values().next().value
              : null;
          };
        }

        let folder = new Prototype(i => i._folder && i._folder.id);
        let template = new Prototype(i => i._template && i._template.id);
        let type = new Prototype(
          i => i._template && i._template._type && i._template._type.id
        );
        let receiver = new Prototype(i => i._receiver && i._receiver.id);
        let creditor = new Prototype(i => i._creditor && i._creditor.id);
        let sender = new Prototype(i => i._sender && i._sender.id);
        let status = new Prototype(i => i.status);
        let name = new Prototype(i => i.name);
        let notices = new Prototype(i => i.notices);
        let language = new Prototype(i => i.language);

        this.selected.forEach(i => {
          folder.add(i);
          template.add(i);
          type.add(i);
          receiver.add(i);
          creditor.add(i);
          sender.add(i);
          status.add(i);
          name.add(i);
          notices.add(i);
          language.add(i);
        });
        this.document = {
          _folder: {
            id: folder.get()
          },
          _template: {
            id: template.get(),
            _type: { id: type.get() }
          },
          _receiver: { id: receiver.get() },
          _creditor: { id: creditor.get() },
          _sender: { id: sender.get() },
          status: status.get(),
          final: false,
          name: name.get(),
          notices: notices.get(),
          language: language.get()
        };
      },
      deep: true
    }
  },
  computed: {
    template_id: {
      get() {
        return this.document._template.id;
      },
      set(id) {
        this.document._template.id = id;
        if (id) {
          this.$store.dispatch("documentTemplateStore/get", {
            id
          });
        } else {
          this.$store.dispatch("documentTemplateStore/clearItem");
        }
      }
    },
    templates: {
      get() {
        return this.$store.getters["documentTemplateStore/getList"].filter(
          i => i.type === this.type_id
        );
      }
    },
    type_id: {
      get() {
        return (((this.selected[0] || {})._template || {})._type || {}).id;
      }
    },
    type() {
      if (this.type_id) {
        return this.types.find(e => e.id === this.type_id) || {};
      }
      return {};
    },
    statuses() {
      return (
        ((this.selected[0] && this.selected[0]._template._type) || {})
          .statuses || []
      );
    },
    types: {
      get() {
        return this.$store.getters["documentTypeStore/getList"];
      }
    },
    template: {
      get() {
        return this.$store.getters["documentTemplateStore/getItem"];
      }
    },
    languages: {
      get() {
        return Object.keys(this.template.localization || {});
      }
    },
    folders: {
      get() {
        return this.$store.getters["folderStore/getList"].filter(a =>
          a._permissions.find(p => p === "folder.update")
        );
      }
    },
    draftCount() {
      return (this.selected || []).reduce((ac, i) => {
        return ac + i.draft;
      }, 0);
    }
  },
  methods: {
    updateCreditor(val) {
      this.document._creditor.id = val;
    },
    updateSender(val) {
      this.document._sender.id = val;
    },
    updateReceiver(val) {
      this.document._receiver.id = val;
    },
    close() {
      this.$emit("update:dialog", false);
    },
    update() {
      this.clearBackEndErrors();
      if (this.$refs.form.validate()) {
        this.loading = true;
        let values = {
          ...this.document
        };
        if (this.document.final) {
          values.draft = false;
        } else {
          delete values.draft;
        }
        delete values.final;
        for (let propName in values) {
          if (
            (!values[propName] && propName !== "draft") ||
            (typeof values[propName] === "object" && !values[propName].id)
          ) {
            delete values[propName];
          }
        }
        this.$store
          .dispatch("documentStore/updateList", {
            values,
            ids: this.selected.map(i => i.id),
            errorHandler: this.errorHandler.bind(this, () => {
              this.$refs.form.validate();
            }),
            onSuccess: () => {
              this.onSuccess();
              this.close();
            }
          })
          .finally(() => (this.loading = false));
      }
    }
  },
  mounted() {
    this.$store.dispatch("folderStore/getList", {
      params: { limit: -1 }
    });
    this.$store.dispatch("documentTypeStore/getList", {
      params: { limit: -1 }
    });
    this.$store.dispatch("documentTemplateStore/getList", {
      params: { limit: -1 }
    });
  }
};
</script>

<style scoped></style>
